export const ICON_BTN: React.CSSProperties = {
  flexShrink: 0,
  padding: 4,
  border: 'none',
  background: 'transparent',
  borderRadius: 9,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'rgba(var(--ink-rgb),0.9)',
};

export const ROUND_BTN: React.CSSProperties = {
  flexShrink: 0,
  width: 30,
  height: 30,
  borderRadius: '50%',
  border: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};
